// External Dependencies
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';

// Internal Dependencies
import { BackToButton } from 'components/shared';
import { tableQueryParams } from 'state/table/selectors';
import { useGetEstimate } from 'hooks/api/estimates';

// Local Dependencies
import EstimateInfoContent from './EstimateInfoContent';

// Component Definition
const EstimateShow = (): JSX.Element | null => {
  const { id } = useParams();

  const estimatesParams = useSelector(tableQueryParams('estimates'));

  const { data } = useGetEstimate(id as string);

  if (!data) {
    return null;
  }

  return (
    <>
      <Box marginBottom={3}>
        <BackToButton
          context="All Estimates"
          navigateTo={`/estimates${estimatesParams}`}
        />
      </Box>

      <EstimateInfoContent data={data.data} />
    </>
  );
};

export default EstimateShow;
